import React from 'react';

export type PublicPageSettings = {
  pageWidth?: string;
};

const PublicPageContext = React.createContext<
  [PublicPageSettings, (publicPageSettings: PublicPageSettings) => void] | null
>(null);

export default PublicPageContext;
